import { ReactElement } from 'react'
import { AuthLayout } from '../../components/layout/Auth/AuthLayout'

export default function EmptyLoading(): ReactElement {
  return <AuthLayout />
}
